import { render } from "./QuickpayPaymentCard.vue?vue&type=template&id=a472f450&scoped=true"
import script from "./QuickpayPaymentCard.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentCard.vue?vue&type=script&lang=js"

import "./QuickpayPaymentCard.vue?vue&type=style&index=0&id=a472f450&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a472f450"]])

export default __exports__